import React from 'react';

const Username = ({ first_name, last_name }) => (
  <span>
    {`${first_name} ${last_name}`}
  </span>
)

const Description = ({ description }) => (
  <span>{description}</span>
)

const Timestamp = ({ created_at }) => {
  const timestamp = new Date(created_at)

  return(
    <span>{timestamp.toLocaleString()}</span>
  )
}

const ChangeLogEntry = ({created_at, description, diff, user}) => (
  <li>
    <Timestamp created_at={created_at}/>
    <Description description={description} />
    <Username {...user} />
  </li>
)

export default ChangeLogEntry



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ChangeLogEntry.js